import { PublicKey } from '@solana/web3.js';
import BN from 'bn.js';

export const getTokenPrice = async (symbol: string): Promise<number> => {
  try {
    const response = await fetch(`https://api.solscan.io/market?symbol=${symbol}`);
    const json = await response.json();
    return json.data?.priceUsdt ?? 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const getTokens = async (pk: string): Promise<any> => {
  try {
    const response = await fetch(`https://api.solscan.io/account/tokens?address=${pk}`);
    const json = await response.json();
    console.error(json?.message);
    return json.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getTokensInfo = async (addr: string): Promise<any> => {
  try {
    const response = await fetch(`https://api.solscan.io/account?address=${addr}`);
    const json = await response.json();
    return json.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getNftInfo = async (mint: string): Promise<any> => {
  try {
    const response = await fetch(`https://asia-south1-cyclos-finance.cloudfunctions.net/getNFT?mint=${mint}`);
    const json = await response.json();
    return json;
  } catch (error) {
    console.error(error);
    return {};
  }
};



export function truncateToDecimals(num: number, dec = 2) {
  const calcDec = Math.pow(10, dec);
  return Math.trunc(num * calcDec) / calcDec;
}

export function isValidPublicKey(key: any) {
  if (!key) {
    return false;
  }
  try {
    new PublicKey(key);
    return true;
  } catch {
    return false;
  }
}

export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const percentFormat = new Intl.NumberFormat(undefined, {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function floorToDecimal(
  value: number,
  decimals: number | undefined | null,
) {
  return decimals
    ? Math.floor(value * 10 ** decimals) / 10 ** decimals
    : Math.floor(value);
}

export function roundToDecimal(
  value: number,
  decimals: number | undefined | null,
) {
  return decimals ? Math.round(value * 10 ** decimals) / 10 ** decimals : value;
}

export function getDecimalCount(value: number): number {
  if (
    !isNaN(value) &&
    Math.floor(value) !== value &&
    value.toString().includes('.')
  )
    return value.toString().split('.')[1].length || 0;
  if (
    !isNaN(value) &&
    Math.floor(value) !== value &&
    value.toString().includes('e')
  )
    return parseInt(value.toString().split('e-')[1] || '0');
  return 0;
}

export function divideBnToNumber(numerator: BN, denominator: BN): number {
  const quotient = numerator.div(denominator).toNumber();
  const rem = numerator.umod(denominator);
  const gcd = rem.gcd(denominator);
  return quotient + rem.div(gcd).toNumber() / denominator.div(gcd).toNumber();
}

export function getTokenMultiplierFromDecimals(decimals: number): BN {
  return new BN(10).pow(new BN(decimals));
}



export function abbreviateAddress(address: PublicKey, size = 4) {
  const base58 = address?.toBase58();
  return base58.slice(0, size) + '…' + base58.slice(-size);
}

export function isEqual(obj1: any, obj2: any, keys: any) {
  if (!keys && Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  keys = keys || Object.keys(obj1);
  for (const k of keys) {
    if (obj1[k] !== obj2[k]) {
      // shallow comparison
      return false;
    }
  }
  return true;
}

export function flatten(obj: any, { prefix = '', restrictTo }: any) {
  let restrict = restrictTo;
  if (restrict) {
    restrict = restrict.filter((k: any) => obj.hasOwnProperty(k));
  }
  const result: any = {};
  (function recurse(obj, current, keys) {
    (keys || Object.keys(obj)).forEach((key: any) => {
      const value = obj[key];
      const newKey = current ? current + '.' + key : key; // joined key with dot
      if (value && typeof value === 'object') {
        // @ts-ignore
        recurse(value, newKey); // nested object
      } else {
        result[newKey] = value;
      }
    });
  })(obj, prefix, restrict);
  return result;
}